<template>
  <LoadingIcon v-if="isLoading" size="15px" />
  <section class="wrapper-activities" v-else-if="!isLoading && healthKitDataByDate.length">
    <activity-card
      v-for="(data, index) in healthKitDataByDate"
      :key="index"
      :id="data.id"
      :code="data.code"
      :value="data.value"
      :unit="data.unit"
      :startDate="data.startDate"
      :endDate="data.endDate"
      :logo="category?.logo"
      :colorTitle="data.code?.nameToShow?.color || '#000'"
      @cardSelected="
        emits('onSelectCategoryDetail', {
          code: data.code,
          rangeDate: {
            startDate: new Date(
              new Date(data.startDate).setDate(new Date(data.startDate).getDate() - 1)
            ),
            endDate: new Date(new Date(data.endDate).setDate(new Date(data.endDate).getDate() + 1)),
          },
        })
      "
    />
  </section>
  <div v-else>No data found</div>
</template>

<script lang="js" setup>
import { onMounted, ref, inject } from 'vue';
import ActivityCard from '../molecules/ActivityCard.vue';
import { getHealthKitDataByCategory } from '../services/healthCategories.services';
import { HK_CATEGORIES, HK_CATEGORIES_SLEEP_ANALYSIS, TYPE_COLLECTION } from '../utils/HealthKit';
import { toast } from 'vue3-toastify';
import LoadingIcon from '@/components/loading';

const props = defineProps({
  category: {
    type: {
      name: String,
      dataType: Array,
      logo: String,
      chartType: String,
    },
    required: true,
  },
});

const emits = defineEmits(['onSelectCategoryDetail']);
const collectedFormData = inject('collectedFormData');
const healthKitDataByDate = ref([]);
const isLoading = ref(false);

onMounted(async () => {
  try {
    isLoading.value = true;

    const promises = props.category.dataTypes.map((dataType) =>
      getHealthKitDataByCategory({
        userId: collectedFormData.userId,
        studyId: collectedFormData.studyId,
        codeFilter: dataType.key,
      })
    );
    const results = await Promise.allSettled(promises);
    const fulfilledResults = results
      .filter((result) => result.status === 'fulfilled' && result.value.length > 0)
      .map((result, index) => {
        const healthKitData = result.value[0]; 

        return {
          id: healthKitData.id,
          code: {
            ...healthKitData.code,
            nameToShow: props.category.dataTypes[index], 
          },
          value: healthKitData.value,
          unit: healthKitData.unit,
          startDate: healthKitData.displayDate, 
          endDate: healthKitData.displayDate,   
          lastDataCollectedAt: healthKitData.lastDataCollectedAt,
          submittedAt: healthKitData.submittedAt,
          displayDate: healthKitData.displayDate,
        };
      });

    healthKitDataByDate.value = fulfilledResults;
  } catch (error) {
    toast.error(error.message);
  } finally {
    isLoading.value = false;
  }
});
</script>

<style lang="scss" scoped>
.wrapper-activities {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  align-items: center;
}
</style>
